<template>
  <div class="layout-home-banner-card"
    :class="[collapsed ? 'layout-home-banner-card-collapsed' : '', layoutHomeBannerClass]"
    :style="mergedStyle">
    <el-carousel
      ref="elCarouselRef"
      height="100%"
      class="banner"
      :class="layoutHomeBannerClass"
      :autoplay="true"
      :interval="5000"
      v-show="!collapsed"
      :indicator-position="collapsed ? 'none' :''"
      @change="onBannerChange">
      <el-carousel-item v-for="(item, index) in bannerList" :key="item._key" ref="elCarouselItem" :class="{ 'hide': index !== activedIndex }">
        <BannerItem :data="item" :collapsed="collapsed" @click="onClick" />
      </el-carousel-item>
    </el-carousel>
    <div class="layout-home-bannerArrowGroup" :style="bannerArrowGroupStyle" v-if="!collapsed && bannerList.length > 6">
      <img class="banner-l" src="./images/banner-l.png" @click="bannerArrowClick('prev')" alt="左箭头">
      <img class="banner-r" src="./images/banner-r.png" @click="bannerArrowClick('next')" alt="右箭头">
    </div>
    <VerticalCarousel :list="bannerList" v-show="collapsed" @click="onClick" ref="verticalCarousel"/>
    <div class="banner-action-box">
      <div class="action-left" @click="openHistory">
        历史
      </div>
      <div class="action-right"  @click="handleCollapsed">
        <i class="el-icon-arrow-up" v-if="!collapsed"></i>
        <i class="el-icon-arrow-down" v-else></i>
      </div>
    </div>
    <div id="layout-home-dialog"></div>
    <!-- <HomeDrawer ref="homeDrawer"  @click="onHistoryClick" />
    <PagerDialog ref="pagerDialog" @click="onClick" @page-change="onPagerChange"/> -->
    <BannerDialog ref="bannerDialog" @updateFeedback="updateFeedback" @updateRead="updateRead" />
  </div>
</template>

<script>
  import mixins from 'public/mixins'
  import {random} from 'public/utils'
  // 单个轮播图卡片
  import BannerItem from './banner-item'
  // 视频播放弹窗
  // import VideoDialog from './video-dialog'
  // 视频弹窗
  import VerticalCarousel from './vertical-carousel.vue'
  // 上报数据函数
  import {updateFeedback, updateRead, updateKSRead, REPORT_ACCESS_URL, handleJumpTo, isEmptyImg, isBannerImg} from './utils'
  import BannerDialog from './banner-dialog.vue'
  export default {
    props: {
      height: {
        type: Number
      }
    },
    mixins: [mixins],
    components: {
      BannerItem,
      BannerDialog,
      // VideoDialog,
      VerticalCarousel,
    },
    data() {
      return {
        title: '',
        collapsed: false,
        dialogData: null,
        activedIndex: 0,
        bannerList: [],
        timer: null,
      }
    },
    computed: {
      mergedStyle () {
        if (this.collapsed) {
          return {
            'height': '42px',
            'min-height': '42px'
          }
        }
        return {
          'height': this.height + 'px',
          'min-height': this.height + 'px'
        }
      },
      bannerArrowGroupStyle() {
        const groupIndex = Math.floor(this.activedIndex / 6)
        const startIndex = groupIndex * 6
        const length = this.bannerList.slice(startIndex, startIndex + 6).length
        const bannerListLength = this.bannerList.length > 6 ? length : this.bannerList.length || 0
        const lineWidth = 24
        const arrowWidth = 24
        const indicatorsLeft = 68 - arrowWidth
        return {
          width: bannerListLength * lineWidth + indicatorsLeft + 'px'
        }
      },
      layoutHomeBannerClass() {
        const groupIndex = Math.floor(this.activedIndex / 6)
        return `layoutHomeBanner${groupIndex}`
      }
    },
    created () {
      this.bannerDialog = null // 远程弹窗
      this.$bus.$once('APP_LOADED', this.init(true))
    },
    mounted () {
      // 检测页面是否有操作，无操作，则不轮询
      this.mouseXY = ''
      this.oldMouseXY = ''
      window.addEventListener('mousemove', this.mouseMoveEvent)
    },
    activated () {
      this.init(true)
    },
    deactivated () {
      this.clearTimer()
    },
    methods: {
      clearTimer () {
        window.clearInterval(this.timer)
        this.timer = null
      },
      mouseMoveEvent (e) {
        this.mouseXY = `${e.x},${e.y}`
      },
      async openHistory () {
        this.openDialog('homeDrawer')
        // this.$refs.homeDrawer.open()
      },
      async getBannerList () {
        try {
          const res = await this.$http('kuasheng.appsManager.ksApplicationAdv.getNewErpHomePageAdvList', null, { cancel: true, log: false, axios: { headers: { 'X-menu-id': '2820215716730110', appkey: '10184' } } })
          this.bannerList = res.filter(item => !!item.iconUrlV2).map(item => {
            return {
              ...item,
              _key: random()
            }
          })
        } catch (error) {
          this.bannerList = []
        }
      },
      async init (immediate = false, time = 5 * 60) {
        this.clearTimer()
        // 页面长时间无操作无需获取banner
        const getLatestBannerList = async () => {
          if (this.mouseXY !== this.oldMouseXY) {
            this.oldMouseXY = this.mouseXY
            this.getBannerList()
          }
        }
        // 立即获取最新banner
        if (immediate) {
          this.getBannerList()
        }
        this.timer = setInterval(() => {
          getLatestBannerList()
        }, time * 1000)
      },
      bannerArrowClick(type) {
        const elCarouselRef = this.$refs.elCarouselRef
        const fn = elCarouselRef[type]
        if (fn) {
          fn()
        }
      },
      updateFeedback (data) {
        updateFeedback(data)
      },
      updateRead (data) {
        if (data.accessUrl && data.accessUrl.includes(REPORT_ACCESS_URL)) {
          this.updateKSRead(data)
        }
        // 初始化，上报风采视频需要调取updateRead
        updateRead(data)
      },
      // 初始化远程弹窗组件
      async initBannerDialog () {
        try {
          const bannerDialog = new Promise(window.__ERP_REMOTE_IMPORT__('sys/BssHomeDialog'))
          const res = await bannerDialog
          let Ctor = this.$options._base.extend(res.default)
          // let Ctor = this.$options._base.extend(BssHomeDialog)
          this.bannerDialog = new Ctor({ parent: this })
          const dialogComp = this.bannerDialog.$mount('#layout-home-dialog')
          dialogComp.$on('updateFeedback', (data) => {
            updateFeedback(data)
          })
          dialogComp.$on('updateRead', (data) => {
            if (data.accessUrl && data.accessUrl.includes(REPORT_ACCESS_URL)) {
              this.updateKSRead(data)
            }
            // 初始化，上报风采视频需要调取updateRead
            updateRead(data)
          })
        } catch (error) {
          console.error(error)
        }
      },
      showVideoDialog (item) {
        this.openDialog('videoDialog', item)
      },
      handleCollapsed () {
        if (!this.collapsed) {
          this.$refs.verticalCarousel.handleCollapsed(this.activedIndex)
        } else {
          this.getBannerList()
        }
        this.collapsed = !this.collapsed
      },
      onBannerChange (index) {
        this.activedIndex = index
        if (this.collapsed) return
        const bannerItem = this.bannerList[index]
        if (!bannerItem) return
        if (isEmptyImg(bannerItem)) return
        if (isBannerImg(bannerItem)) {
          updateRead(bannerItem)
        }
      },
      // 历史记录-翻页中转弹窗-翻页 响应回调
      onPagerChange (data) {
        this.updateRead(data)
        this.updateFeedback(data)
      },
      onClick (data) {
        if (isEmptyImg(data)) return
        // 处理图片
        if (isBannerImg(data)) {
          if ([1, 3].includes(data.skipType)) {
            updateFeedback(data)
          }
          // 包含 /inform-video/#/?media 的链接 打开嵌套iframe视频弹窗
          // 跨越风采 /ky-style-video/#/?media
          const urls = ['/inform-video/#/?media', '/ky-style-video/#/?media', '/ky-style/#/detail']
          if (data.accessUrl && urls.some(url => data.accessUrl.includes(url))) {
            updateRead(data)
            this.openDialog('iframeDialog', data.accessUrl)
            return
          }
          this.updateKSRead(data)
          handleJumpTo(data)
          return
        }
        // 处理视频
        // 视频已读
        updateRead(data)
        this.showVideoDialog(data)
      },
      onHistoryClick (item, list) {
        // 打开历史记录-分页弹窗
        this.$refs.bannerDialog.open('pagerDialog', item, list)
      },
      // 处理跨越风采图点击上报
      updateKSRead (data) {
        if (data && data.accessUrl && data.accessUrl.includes(REPORT_ACCESS_URL)) {
          updateKSRead(data)
        }
      },
      async openDialog (compKey, data) {
        // if (!this.bannerDialog) {
        //   await this.initBannerDialog()
        // }
        this.$refs.bannerDialog.open(compKey, data)
      }
    },
    beforeDestroy () {
      this.clearTimer()
      window.removeEventListener('mousemove', this.mouseMoveEvent)
    }
  }
</script>

<style lang="scss" scoped>
.layout-home-banner-card {
  width: 100%;
  position: relative;
  margin-bottom: 12px;
  border-radius: 12px;
  box-sizing: border-box;
  display: flex;
  height: 176px;
  flex-direction: column;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.06);
  &:not(.layout-home-banner-card-collapsed) {
    border: 1px solid rgba(255, 255, 255, 0.6);
  }
  &:hover {
    .layout-home-bannerArrowGroup {
      display: flex;
    }
  }
  .layout-home-bannerArrowGroup {
    position: absolute;
    z-index: 101;
    bottom: 4px;
    display: flex;
    justify-content: space-between;
    left: 18px;
    pointer-events: none;
    display: none;
    img {
      width: 24px;
      height: 24px;
      cursor: pointer;
      pointer-events: auto;
    }
    .banner-l{
      top: 50%;
    }
  }
  .banner {
    flex: 1;
  }
  /deep/ .el-carousel__arrow {
    display: none;
  }
  /deep/ .el-carousel {
    border-radius: 12px;
    .el-carousel__item.hide {
      pointer-events: none;
    }
    .el-carousel__indicators {
      left: 40px ;
      li {
        display: none;
      }
      transform: translateX(0);
      .el-carousel__button {
        width: 16px;
      }
      &--outside{
        bottom: 0;
        position: absolute;
        button {
          background-color: #fff;
        }
      }
    }
  }
  .banner-action-box {
    position: absolute;
    width: 63px;
    height: 20px;
    border-radius: 5px;
    color: #ffffff;
    right: 12px;
    top: 12px;
    display: flex;
    z-index: 99;
    align-items: center;
    cursor: pointer;
    backdrop-filter: blur(264.8324279785156px);
    background: rgba(0, 0, 0, 0.1);
    .action-left {
      height: 12px;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      font-size: 12px;
      width: 36px;
      text-align: center;
      line-height: 12px;
      &:hover {
        font-weight: 600;
      }
    }
    .action-right {
      padding-left: 10px;
      &:hover {
        font-weight: 600;
      }
    }
  }
  &.layout-home-banner-card-collapsed {
    // background: rgba(255, 255, 255, 0.7);
    background: #ffffff;
    .banner-action-box {
      background: transparent;
      backdrop-filter: none;
      color: rgba(108, 60, 244, 1);
      .action-left {
        border-right-color: rgba(69, 60, 90, 0.1);
      }
    }
  }
}

.layoutHomeBanner0 /deep/ .el-carousel__indicators li:nth-child(-n+6),
.layoutHomeBanner1 /deep/ .el-carousel__indicators li:nth-child(n+7):nth-child(-n+12),
.layoutHomeBanner2 /deep/ .el-carousel__indicators li:nth-child(n+13):nth-child(-n+18),
.layoutHomeBanner3 /deep/ .el-carousel__indicators li:nth-child(n+19):nth-child(-n+24),
.layoutHomeBanner4 /deep/ .el-carousel__indicators li:nth-child(n+25):nth-child(-n+30),
.layoutHomeBanner5 /deep/ .el-carousel__indicators li:nth-child(n+31):nth-child(-n+36),
.layoutHomeBanner6 /deep/ .el-carousel__indicators li:nth-child(n+37):nth-child(-n+42),
.layoutHomeBanner7 /deep/ .el-carousel__indicators li:nth-child(n+43):nth-child(-n+48),
.layoutHomeBanner8 /deep/ .el-carousel__indicators li:nth-child(n+49):nth-child(-n+54),
.layoutHomeBanner9 /deep/ .el-carousel__indicators li:nth-child(n+55):nth-child(-n+60),
.layoutHomeBanner10 /deep/ .el-carousel__indicators li:nth-child(n+61):nth-child(-n+66),
.layoutHomeBanner11 /deep/ .el-carousel__indicators li:nth-child(n+67):nth-child(-n+72),
.layoutHomeBanner12 /deep/ .el-carousel__indicators li:nth-child(n+73):nth-child(-n+78),
.layoutHomeBanner13 /deep/ .el-carousel__indicators li:nth-child(n+79):nth-child(-n+84),
.layoutHomeBanner14 /deep/ .el-carousel__indicators li:nth-child(n+85):nth-child(-n+90),
.layoutHomeBanner15 /deep/ .el-carousel__indicators li:nth-child(n+91):nth-child(-n+96),
.layoutHomeBanner16 /deep/ .el-carousel__indicators li:nth-child(n+97):nth-child(-n+102) {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/banner/index.vue